/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/verifyCredential.config.json";
import provConfig from "../../FullProvenancePageService/config/fullProvenance.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { toast } from "react-hot-toast";

const log: any = LoggerModule?.getInstance();

export interface IVerifyCredentialMethods extends IPluginMethodMap {
  verifyCredential(args: any, apiURL: string): Promise<any>;
}

export interface verifyCredentialProps {
  apiURL?: string;
  credTxId: string;
  gtin: string;
}

export class VerifyCredentialService implements IAgentPlugin {
  readonly methods?: IVerifyCredentialMethods;

  constructor() {
    this.methods = {
      verifyCredential: this.verifyCredential.bind(this),
    };
  }

  private _getImages(images: any[]) {
    let _res: any[] = [];
    images &&
      Array.isArray(images) &&
      images.length > 0 &&
      images.map((item: any, index: number) => {
        if (item) {
          _res.push({
            original: item?.src,
            thumbnail: item?.src,
          });
        }
      });
    console.log(` images :`, _res);

    return _res;
  }

  private _getOrganizationIndo(data: any) {
    let _socialLink =
      data &&
      data?.socialLinks &&
      Array.isArray(data?.socialLinks) &&
      data?.socialLinks.length > 0
        ? data?.socialLinks.map((item: any, index: number) => {
            return {
              ...item,
              type: `social-${item?.type}`,
            };
          })
        : [];

    return {
      ...data,
      socialLinks: _socialLink,
    };
  }

  private _getDefaultCenter(geoJson: any) {
    if (geoJson) {
      let coordinates: any[] =
        geoJson?.features &&
        Array.isArray(geoJson?.features) &&
        geoJson?.features.length > 0
          ? geoJson?.features[0]?.geometry?.coordinates
          : [];
      if (coordinates && coordinates.length > 0) {
        let defaultCenter = {
          lat: coordinates[0],
          lng: coordinates[1],
        };

        console.log(`defaultCenter in service:`, defaultCenter);
        return defaultCenter;
      }
    }
  }

  private _getMarkers(geoJson: any) {
    if (geoJson) {
      let markers: any = [];
      geoJson?.features &&
        Array.isArray(geoJson?.features) &&
        geoJson?.features.length > 0 &&
        geoJson?.features.forEach((item: any, index: number) => {
          if (item?.geometry?.type === "Point") {
            item?.geometry?.coordinates &&
              Array.isArray(item?.geometry?.coordinates) &&
              item?.geometry?.coordinates.length > 0 &&
              markers.push({
                lat: item?.geometry?.coordinates[1],
                lng: item?.geometry?.coordinates[0],
              });
          }
        });
      console.log(`geoJson in service:`, markers);
      return markers;
    }
  }

  async verifyCredential(args: verifyCredentialProps) {
    console.log(`args in full provenance service :`, args);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.verifyCredentialEP}`,
        {
          gtin: args?.gtin,
          credTxId: args?.credTxId,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.data) {
        let _data = res?.data?.data;
        console.log(`on Success :`, _data);

        return {
          ..._data,
          images: this._getImages(_data?.ProvStepImages?.provImages),
          productTitleCard: _data?.ProvStepTitleCard,
          provenanceStepTitle: _data?.ProvDetailInfo,
          provenanceDetailInfo: {
            ..._data?.ProvDetailInfo,
            provGeoJson: this._getMarkers(_data?.provMapProps?.geojson),
            defaultCenter: this._getDefaultCenter(
              _data?.provMapProps?.geojson
            ),
            defaultZoom: 7,
            googleMapAPIKey: provConfig?.googleMapAPIKey
          },
          isVerified: true
          // gtinKey: gtin,
          // description: ele?.ProvDetailInfo?.subtitle
          //   ? ele?.ProvDetailInfo?.subtitle
          //   : ele?.ProvDetailInfo?.aboutProvInfo,
          // title: ele?.ProvDetailInfo?.title
          //   ? ele?.ProvDetailInfo?.title
          //   : "",
          // tag: ele?.ProvDetailInfo?.tag
          //   ? ele?.ProvDetailInfo?.tag
          //   : "",
        };
      }
      //}
    } catch (err: any) {
      console.log(`on error :`, err);
      toast.error(`${err?.response?.data?.error_message}`);
      // return err;
    }
  }
}
